import { isEmpty } from "lodash";
import AttributeValues from "./AttributeValues";
import {
  nameValue,
  addressValue,
  telecomValue,
  identifierValue,
  isEmptyAddressMap,
  isEmptyIdentifierMap,
  isEmptyNameMap,
  isEmptyTelecomMap,
} from "../../../../../src/utils/functionUtils";

export const ExtensionURLs = Object.freeze({
  birthDateOverride:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideBirthDate/",
  genderOverride:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideGender/",
  multipleBirthBooleanOverride:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideMultipleBirthIndicator/",
  genericOverride:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#override",
  phoneArea: "http://hl7.org/fhir/StructureDefinition/contactpoint-area",
  phonePhExchange:
    "http://hl7.org/fhir/StructureDefinition/contactpoint-phExchange",
  phonePhNumber:
    "http://hl7.org/fhir/StructureDefinition/contactpoint-phNumber",
  phoneCountry:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#contactpoint-phStdInd",
  addressSrcTimeStamp:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#address-srcTmStmp",
  attrCode:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#attrCode",
  overriddenBy:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#override-updatedBy",
  overrideReason:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#override-reason",
  overrideTimestamp:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#override-timestamp",
  dobOverriddenBy:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideBirthDate-updatedBy",
  dobOverrideReason:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideBirthDate-reason",
  dobOverrideTimestamp:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideBirthDate-timestamp",
  genderOverriddenBy:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideGender-updatedBy",
  genderOverrideReason:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideGender-reason",
  genderOverrideTimestamp:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideGender-timestamp",
  multipleBirthOverriddenBy:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideMultipleBirthIndicator-updatedBy",
  multipleBirthOverrideReason:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideMultipleBirthIndicator-reason",
  multipleBirthOverrideTimestamp:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideMultipleBirthIndicator-timestamp",
  genderRestore:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restoreGender/",
  multipleBirthBooleanRestore:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restoreMultipleBirthIndicator/",
  birthDateRestore:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restoreBirthDate/",
  dobRestoredBy:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restoreBirthDate-updatedBy",
  dobRestoreReason:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restoreBirthDate-reason",
  dobRestoreTimestamp:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restoreBirthDate-timestamp",
  genderRestoredBy:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restoreGender-updatedBy",
  genderRestoreReason:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restoreGender-reason",
  genderRestoreTimestamp:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restoreGender-timestamp",
  multipleBirthRestoredBy:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restoreMultipleBirthIndicator-updatedBy",
  multipleBirthRestoreReason:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restoreMultipleBirthIndicator-reason",
  multipleBirthRestoreTimestamp:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restoreMultipleBirthIndicator-timestamp",
  restoredBy:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restore-updatedBy",
  restoreReason:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restore-reason",
  restoreTimestamp:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restore-timestamp",
  restoreAttrCode:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#restore-attrCode",
  genericRestore:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#restore",
  sourceCode:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#sourceCode",
  coverageEndDate:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#coverageEndDate",
  coverageEndDateTimestamp:
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#coverageEndDateTimestamp",
});

export const getOverrideExtensionURLs = (attribute) => {
  switch (attribute) {
    case AttributeLabels.BIRTHDATE:
      return BirthDateOverrideURLs;
    case AttributeLabels.GENDER:
      return GenderOverrideURLs;
    case AttributeLabels.MULTIPLE_BIRTH_BOOLEAN:
      return MultipleBirthOverrideURLs;
    default:
      return GenericOverrideURLs;
  }
};

export const getRestoreExtensionURLs = (attribute) => {
  switch (attribute) {
    case AttributeLabels.BIRTHDATE:
      return BirthDateRestoreURLs;
    case AttributeLabels.GENDER:
      return GenderRestoreURLs;
    case AttributeLabels.MULTIPLE_BIRTH_BOOLEAN:
      return MultipleBirthRestoreURLs;
    default:
      return GenericRestoreURLs;
  }
};

/**
 * Override extension URLs for birthDate including audit extensions
 */
export const BirthDateOverrideURLs = Object.freeze({
  override: ExtensionURLs.birthDateOverride,
  overriddenBy: ExtensionURLs.dobOverriddenBy,
  overrideReason: ExtensionURLs.dobOverrideReason,
  overrideTimestamp: ExtensionURLs.dobOverrideTimestamp,
});

/**
 * Override extension URLs for gender including audit extensions
 */
export const GenderOverrideURLs = Object.freeze({
  override: ExtensionURLs.genderOverride,
  overriddenBy: ExtensionURLs.genderOverriddenBy,
  overrideReason: ExtensionURLs.genderOverrideReason,
  overrideTimestamp: ExtensionURLs.genderOverrideTimestamp,
});

/**
 * Override extension URLs for multipleBirthBoolean including audit extensions
 */
export const MultipleBirthOverrideURLs = Object.freeze({
  override: ExtensionURLs.multipleBirthBooleanOverride,
  overriddenBy: ExtensionURLs.multipleBirthOverriddenBy,
  overrideReason: ExtensionURLs.multipleBirthOverrideReason,
  overrideTimestamp: ExtensionURLs.multipleBirthOverrideTimestamp,
});

/**
 * Generic override extension URLs including audit extensions
 */
export const GenericOverrideURLs = Object.freeze({
  override: ExtensionURLs.genericOverride,
  overriddenBy: ExtensionURLs.overriddenBy,
  overrideReason: ExtensionURLs.overrideReason,
  overrideTimestamp: ExtensionURLs.overrideTimestamp,
});

/**
 * Restore extension URLs for birthDate including audit extensions
 */
export const BirthDateRestoreURLs = Object.freeze({
  restore: ExtensionURLs.birthDateRestore,
  restoredBy: ExtensionURLs.dobRestoredBy,
  restoreReason: ExtensionURLs.dobRestoreReason,
  restoreTimestamp: ExtensionURLs.dobRestoreTimestamp,
});

/**
 * Restore extension URLs for gender including audit extensions
 */
export const GenderRestoreURLs = Object.freeze({
  restore: ExtensionURLs.genderRestore,
  restoredBy: ExtensionURLs.genderRestoredBy,
  restoreReason: ExtensionURLs.genderRestoreReason,
  restoreTimestamp: ExtensionURLs.genderRestoreTimestamp,
});

/**
 * Restore extension URLs for multipleBirthBoolean including audit extensions
 */
export const MultipleBirthRestoreURLs = Object.freeze({
  restore: ExtensionURLs.multipleBirthBooleanRestore,
  restoredBy: ExtensionURLs.multipleBirthRestoredBy,
  restoreReason: ExtensionURLs.multipleBirthRestoreReason,
  restoreTimestamp: ExtensionURLs.multipleBirthRestoreTimestamp,
});

/**
 * Generic Restore extension URLs including audit extensions
 */
export const GenericRestoreURLs = Object.freeze({
  restore: ExtensionURLs.genericRestore,
  restoredBy: ExtensionURLs.restoredBy,
  restoreReason: ExtensionURLs.restoreReason,
  restoreTimestamp: ExtensionURLs.restoreTimestamp,
});

export const AttributeLabels = Object.freeze({
  NAME: "name",
  IDENTIFIER: "identifier",
  ADDRESS: "address",
  GENDER: "gender",
  BIRTHDATE: "birthDate",
  PHONE: "phone",
  EMAIL: "email",
  TELECOM: "telecom",
  MULTIPLE_BIRTH_BOOLEAN: "multipleBirthBoolean",
});

export const AttributeDisplayLabels = Object.freeze({
  NAME: "Name",
  IDENTIFIER: "Identifier",
  ADDRESS: "Address",
  GENDER: "Gender",
  BIRTHDATE: "Date of Birth",
  PHONE: "Phone",
  EMAIL: "Email",
  TELECOM: "Telecom",
  MULTIPLE_BIRTH_BOOLEAN: "Multiple Birth Indicator",
});

export const ActionLabels = Object.freeze({
  INVALID: "invalid",
  INACTIVE: "inactive",
  REPLACE: "replace",
  RESTORE: "restore",
  NEW: "new",
});

export const ActionDisplayLabels = Object.freeze({
  INVALID: "Invalidate",
  INACTIVE: "Inactivate",
  REPLACE: "Replace",
  RESTORE: "Restore",
  NEW: "New",
});

export const AuditTypeDisplayLabels = Object.freeze({
  OVERRIDE: "Override",
  RESTORE: "Restore Override",
});

export const topLevelExtensionAttributes = [
  AttributeLabels.BIRTHDATE,
  AttributeLabels.GENDER,
  AttributeLabels.MULTIPLE_BIRTH_BOOLEAN,
];

export const attributeLevelExtensionAttributes = [
  AttributeLabels.NAME,
  AttributeLabels.ADDRESS,
  AttributeLabels.TELECOM,
  AttributeLabels.IDENTIFIER,
];

/**
 * Normalizes attribute names to their base types. Used mainly for telecom attributes.
 *
 * @param {string} attribute - The attribute name to normalize.
 * @returns {string} - The normalized attribute name.
 */
export const normalizeAttributeName = (attribute) => {
  switch (attribute) {
    case AttributeLabels.EMAIL:
    case AttributeLabels.PHONE:
      return AttributeLabels.TELECOM;
    default:
      return attribute;
  }
};

/**
 * Returns an array of fields to be extracted for a given attribute.
 *
 * @param {string} attribute - The attribute for which to get value fields.
 * @returns {Array} - An array of field names to be extracted.
 */
export const getAttributeFields = (attribute) => {
  switch (attribute) {
    case AttributeLabels.ADDRESS:
      return [
        "use",
        "line",
        "city",
        "district",
        "state",
        "country",
        "postalCode",
        "period",
      ];
    case AttributeLabels.NAME:
      return ["use", "family", "given", "suffix", "period"];
    case AttributeLabels.PHONE:
    case AttributeLabels.EMAIL:
      return ["use", "system", "value", "period"];
    case AttributeLabels.IDENTIFIER:
      return ["use", "system", "value", "type", "period"];
    case AttributeLabels.BIRTHDATE:
      return ["birthDate"];
    case AttributeLabels.GENDER:
      return ["gender"];
    default:
      return [];
  }
};

/**
 * Returns an array of objects containing different parts of a phone number and their respective indexes. Useful for
 * handling phone number extensions.
 *
 * @returns {Array} - An array of objects with URL, start, and end indexes for phone number sections.
 */
export const getPhoneExtensionSections = () => {
  return [
    { url: ExtensionURLs.phoneArea, start: 0, end: 3 },
    { url: ExtensionURLs.phonePhExchange, start: 3, end: 6 },
    { url: ExtensionURLs.phonePhNumber, start: 6, end: 10 },
  ];
};

/**
 * Returns an array of extension URLs related to phone number components.
 *
 * @returns {Array} - An array of extension URLs for phone number components.
 */
export const getPhoneExtensionURLs = () => {
  return [
    ExtensionURLs.phoneArea,
    ExtensionURLs.phonePhExchange,
    ExtensionURLs.phonePhNumber,
    ExtensionURLs.phoneCountry,
  ];
};

/**
 * Returns the appropriate override audit extension URLs based on the attribute.
 *
 * @param {string} attribute - The attribute for which to get override audit extension URLs.
 * @returns {Object} - An object containing the override audit extension URLs.
 */
export const getOverrideAuditExtensionURLs = (attribute) => {
  switch (attribute) {
    case AttributeLabels.BIRTHDATE:
      return {
        overriddenBy: ExtensionURLs.dobOverriddenBy,
        overrideReason: ExtensionURLs.dobOverrideReason,
        overrideTimestamp: ExtensionURLs.dobOverrideTimestamp,
      };
    case AttributeLabels.GENDER:
      return {
        overriddenBy: ExtensionURLs.genderOverriddenBy,
        overrideReason: ExtensionURLs.genderOverrideReason,
        overrideTimestamp: ExtensionURLs.genderOverrideTimestamp,
      };
    case AttributeLabels.MULTIPLE_BIRTH_BOOLEAN:
      return {
        overriddenBy: ExtensionURLs.multipleBirthOverriddenBy,
        overrideReason: ExtensionURLs.multipleBirthOverrideReason,
        overrideTimestamp: ExtensionURLs.multipleBirthOverrideTimestamp,
      };
    default:
      return {
        overriddenBy: ExtensionURLs.overriddenBy,
        overrideReason: ExtensionURLs.overrideReason,
        overrideTimestamp: ExtensionURLs.overrideTimestamp,
      };
  }
};

/**
 * Returns the appropriate restore audit extension URLs based on the attribute.
 *
 * @param {string} attribute - The attribute for which to get restore audit extension URLs.
 * @returns {Object} - An object containing the restore audit extension URLs.
 */
export const getOverrideRestoreAuditExtensionURLs = (attribute) => {
  switch (attribute) {
    case AttributeLabels.BIRTHDATE:
      return {
        restoredBy: ExtensionURLs.dobRestoredBy,
        restoreReason: ExtensionURLs.dobRestoreReason,
        restoreTimestamp: ExtensionURLs.dobRestoreTimestamp,
      };
    case AttributeLabels.GENDER:
      return {
        restoredBy: ExtensionURLs.genderRestoredBy,
        restoreReason: ExtensionURLs.genderRestoreReason,
        restoreTimestamp: ExtensionURLs.genderRestoreTimestamp,
      };
    case AttributeLabels.MULTIPLE_BIRTH_BOOLEAN:
      return {
        restoredBy: ExtensionURLs.multipleBirthRestoredBy,
        restoreReason: ExtensionURLs.multipleBirthRestoreReason,
        restoreTimestamp: ExtensionURLs.multipleBirthRestoreTimestamp,
      };
    default:
      return {
        restoredBy: ExtensionURLs.restoredBy,
        restoreReason: ExtensionURLs.restoreReason,
        restoreTimestamp: ExtensionURLs.restoreTimestamp,
      };
  }
};

/**
 * Finds and returns override audit details from top-level extensions in a record for a given attribute.
 *
 * @param {Object} record - The FHIR record.
 * @param {string} attribute - The attribute for which to find override audit details.
 * @returns {Object} - An object containing override audit details (user, reason, timestamp, type).
 */
export const findTopLevelExtensionOverrideAuditDetails = (
  record,
  attribute,
) => {
  const auditExtensionURLs = getOverrideAuditExtensionURLs(attribute);
  const topLevelExtension = record?.extension;
  const user = topLevelExtension?.find(
    (ext) => ext.url === auditExtensionURLs.overriddenBy,
  )?.valueString;
  const reason = topLevelExtension?.find(
    (ext) => ext.url === auditExtensionURLs.overrideReason,
  )?.valueString;
  const timestamp =
    topLevelExtension?.find(
      (ext) => ext.url === auditExtensionURLs.overrideTimestamp,
    )?.valueDateTime ||
    topLevelExtension?.find(
      (ext) => ext.url === auditExtensionURLs.overrideTimestamp,
    )?.valueString;

  const auditDetailsObject = {
    user: user || "-",
    reason: reason || "-",
    timestamp: timestamp || "-",
    type: AuditTypeDisplayLabels.OVERRIDE,
  };

  return auditDetailsObject;
};

/**
 * Finds and returns override audit details from attribute-level extensions in a record for a given attribute.
 *
 * @param {Object} record - The FHIR record.
 * @param {string} attribute - The attribute for which to find override audit details.
 * @returns {Array} - An array of objects containing override audit details (user, reason, timestamp, type).
 */
export const findAttributeLevelExtensionOverrideAuditDetails = (
  record,
  attribute,
) => {
  const auditExtensionURLs = getOverrideAuditExtensionURLs(attribute);

  const auditDetailsList = record?.[attribute]?.map((item) => {
    const extension = item?.extension;

    const user = extension?.find(
      (ext) => ext.url === auditExtensionURLs.overriddenBy,
    )?.valueString;
    const reason = extension?.find(
      (ext) => ext.url === auditExtensionURLs.overrideReason,
    )?.valueString;
    const timestamp =
      extension?.find((ext) => ext.url === auditExtensionURLs.overrideTimestamp)
        ?.valueDateTime ||
      extension?.find((ext) => ext.url === auditExtensionURLs.overrideTimestamp)
        ?.valueString;

    const auditDetailsObject = {
      user: user || "-",
      reason: reason || "-",
      timestamp: timestamp || "-",
      type: AuditTypeDisplayLabels.OVERRIDE,
    };

    return auditDetailsObject;
  });

  return auditDetailsList || [];
};

/**
 * Finds and returns restore audit details from top-level extensions in a record for a given attribute
 *
 * @param {Object} record - The FHIR record.
 * @param {string} attribute - The attribute for which to find restore audit details.
 * @returns {Object} - An object containing restore audit details (user, reason, timestamp, type).
 */
export const findTopLevelExtensionRestoreAuditDetails = (record, attribute) => {
  const auditExtensionURLs = getOverrideRestoreAuditExtensionURLs(attribute);
  const topLevelExtension = record?.extension;
  const user = topLevelExtension?.find(
    (ext) => ext.url === auditExtensionURLs.restoredBy,
  )?.valueString;
  const reason = topLevelExtension?.find(
    (ext) => ext.url === auditExtensionURLs.restoreReason,
  )?.valueString;
  const timestamp =
    topLevelExtension?.find(
      (ext) => ext.url === auditExtensionURLs.restoreTimestamp,
    )?.valueDateTime ||
    topLevelExtension?.find(
      (ext) => ext.url === auditExtensionURLs.restoreTimestamp,
    )?.valueString;

  const auditDetailsObject = {
    user: user || "-",
    reason: reason || "-",
    timestamp: timestamp || "-",
    type: AuditTypeDisplayLabels.RESTORE,
  };

  return auditDetailsObject;
};

/**
 * Finds and returns restore audit details from attribute-level extensions in a record for a given attribute
 *
 * @param {Object} record - The FHIR record.
 * @param {string} attribute - The attribute for which to find restore audit details.
 * @returns {Array} - An array of objects containing restore audit details (user, reason, timestamp, type).
 */
export const findAttributeLevelExtensionRestoreAuditDetails = (
  record,
  attribute,
) => {
  const auditExtensionURLs = getOverrideRestoreAuditExtensionURLs(attribute);

  const auditDetailsList = record?.[attribute]?.map((item) => {
    const extension = item?.extension;

    const user = extension?.find(
      (ext) => ext.url === auditExtensionURLs.restoredBy,
    )?.valueString;
    const reason = extension?.find(
      (ext) => ext.url === auditExtensionURLs.restoreReason,
    )?.valueString;
    const timestamp =
      extension?.find((ext) => ext.url === auditExtensionURLs.restoreTimestamp)
        ?.valueDateTime ||
      extension?.find((ext) => ext.url === auditExtensionURLs.restoreTimestamp)
        ?.valueString;

    const auditDetailsObject = {
      user: user || "-",
      reason: reason || "-",
      timestamp: timestamp || "-",
      type: AuditTypeDisplayLabels.RESTORE,
    };

    return auditDetailsObject;
  });

  return auditDetailsList || [];
};

/**
 * Extracts all audit details (override and restore) from a given record.
 *
 * @param {Object} record - The FHIR record.
 * @returns {Array} - An array of objects containing all audit details with valid timestamps.
 */
export const getAllAuditDetailsFromRecord = (record) => {
  const auditDetails = [];

  topLevelExtensionAttributes.forEach((attr) => {
    const overrideAuditDetails = findTopLevelExtensionOverrideAuditDetails(
      record,
      attr,
    );
    const restoreAuditDetails = findTopLevelExtensionRestoreAuditDetails(
      record,
      attr,
    );
    auditDetails.push(overrideAuditDetails);
    auditDetails.push(restoreAuditDetails);
  });

  attributeLevelExtensionAttributes.forEach((attr) => {
    const overrideAuditDetails =
      findAttributeLevelExtensionOverrideAuditDetails(record, attr);
    const restoreAuditDetails = findAttributeLevelExtensionRestoreAuditDetails(
      record,
      attr,
    );
    auditDetails.push(overrideAuditDetails);
    auditDetails.push(restoreAuditDetails);
  });

  return auditDetails
    .flat()
    .filter((obj) => obj.timestamp !== "-" && !isEmpty(obj.timestamp));
};

/**
 * Finds and returns the latest audit detail from a record that matches the record's last updated time.
 *
 * @param {Object} record - The FHIR record.
 * @returns {Object|null} - The latest audit detail object or null if a match isn't found.
 */
export const findLatestAuditDetail = (record) => {
  const auditDetails = getAllAuditDetailsFromRecord(record);

  // if no audit details are found in the record or the record is empty, early return null
  if (isEmpty(auditDetails) || isEmpty(record)) return null;

  // Find the latest audit detail based on timestamp
  const latestAuditDetail = auditDetails.reduce((a, b) =>
    new Date(a.timestamp) > new Date(b.timestamp) ? a : b,
  );

  // First look for lastUpdatedTime in the record history record, if not found, fallback to eimpLastUpdated from the bundle
  // The record history records have lastUpdatedTime in epoch milliseconds format and the current record in the bundle has
  // eimpLastUpdated in ISO format. If neither are found, return null.
  const recordLastUpdatedTimeGMT = record?.lastUpdatedTime
    ? new Date(Number(record.lastUpdatedTime)).toISOString()
    : record?.eimpLastUpdated
      ? new Date(record.eimpLastUpdated).toISOString()
      : null;

  // Compare the latest audit detail timestamp with record last updated time. A 10 second tolerance is given. If the latest audit detail
  // is within the tolerance, return the latest audit detail as its likely the latest action performed on the record.
  if (latestAuditDetail && recordLastUpdatedTimeGMT) {
    const diff = Math.abs(
      new Date(latestAuditDetail.timestamp).getTime() -
        new Date(recordLastUpdatedTimeGMT).getTime(),
    );
    if (diff <= 10000) {
      return latestAuditDetail;
    }
  }

  return null;
};

/**
 * Returns the appropriate override extension URL based on the attribute.
 *
 * @param {string} attribute - The attribute for which to get the override extension URL.
 * @returns {string} - The override extension URL.
 */
export const getOverrideExtensionURLByAttribute = (attribute) => {
  switch (attribute) {
    case AttributeLabels.BIRTHDATE:
      return ExtensionURLs.birthDateOverride;
    case AttributeLabels.GENDER:
      return ExtensionURLs.genderOverride;
    case AttributeLabels.MULTIPLE_BIRTH_BOOLEAN:
      return ExtensionURLs.multipleBirthBooleanOverride;
    default:
      return ExtensionURLs.genericOverride;
  }
};

/**
 * Returns the appropriate restore extension URL based on the attribute.
 *
 * @param {string} attribute - The attribute for which to get the restore extension URL.
 * @returns {string} - The restore extension URL.
 */
export const getRestoreExtensionURLByAttribute = (attribute) => {
  switch (attribute) {
    case AttributeLabels.BIRTHDATE:
      return ExtensionURLs.birthDateRestore;
    case AttributeLabels.GENDER:
      return ExtensionURLs.genderRestore;
    case AttributeLabels.MULTIPLE_BIRTH_BOOLEAN:
      return ExtensionURLs.multipleBirthBooleanRestore;
    default:
      return ExtensionURLs.genericRestore;
  }
};

/**
 * Returns the appropriate FHIR value type based on the attribute.
 *
 * @param {string} attribute - The attribute for which to get the FHIR value type.
 * @returns {string} - The FHIR value type.
 */
export const getValueTypeByAttribute = (attribute) => {
  switch (attribute) {
    case AttributeLabels.NAME:
      return "valueHumanName";
    case AttributeLabels.ADDRESS:
      return "valueAddress";
    case AttributeLabels.TELECOM:
      return "valueContactPoint";
    case AttributeLabels.IDENTIFIER:
      return "valueIdentifier";
    case AttributeLabels.GENDER:
      return "valueString";
    case AttributeLabels.BIRTHDATE:
      return "valueDate";
    case AttributeLabels.MULTIPLE_BIRTH_BOOLEAN:
      return "valueBoolean";
    case AttributeLabels.PHONE:
      return "valueContactPoint";
    case AttributeLabels.EMAIL:
      return "valueContactPoint";
    default:
      return "valueString";
  }
};

/**
 * Checks if the attribute map is empty based on the attribute type.
 *
 * @param {string} attribute - The attribute to check.
 * @param {Map} attributeMap - The map containing attribute values.
 * @returns {boolean} - True if the attribute map is empty, false otherwise.
 */
export const getIsEmptyAttribute = (attribute, attributeMap) => {
  switch (attribute) {
    case AttributeLabels.ADDRESS:
      return isEmptyAddressMap(attributeMap);
    case AttributeLabels.NAME:
      return isEmptyNameMap(attributeMap);
    case AttributeLabels.PHONE:
    case AttributeLabels.EMAIL:
      return isEmptyTelecomMap(attributeMap);
    case AttributeLabels.IDENTIFIER:
      return isEmptyIdentifierMap(attributeMap);
    default:
      return isEmpty(attributeMap.get(attribute));
  }
};

/**
 * Filters and returns the selected primary records from the given records.
 *
 * @param {Array} records - The array of records to filter.
 * @param {Array} primaryRecords - The array of primary record identifiers.
 * @returns {Array} - The array of selected primary records.
 */
export const SelectedPrimaryRecords = (records, primaryRecords) => {
  return records.filter((r) =>
    primaryRecords.find(
      (pr) => pr.recordId === r.id && pr.source === r.meta.source,
    ),
  );
};

/**
 * Checks if a record contains any of the override extensions.
 *
 * @param {Object} record - The record to check.
 * @returns {boolean} - True if the record has override extensions, false otherwise.
 */
export const recordHasOverride = (record) => {
  const overrideStrings = [
    ExtensionURLs.birthDateOverride,
    ExtensionURLs.genderOverride,
    ExtensionURLs.genericOverride,
  ];
  return overrideStrings.some((str) => JSON.stringify(record).includes(str));
};

export const isEquivalentValue = (val1, val2, attribute) => {
  if (typeof val1 === "string" && typeof val2 === "string") {
    return attribute === "identifier"
      ? val1 === val2
      : val1.toUpperCase() === val2.toUpperCase();
  }
  return false;
};

export const inactivateObject = (obj) => {
  const inactiveObj = { ...obj };

  delete inactiveObj["extension"];
  inactiveObj["use"] = "old";

  return inactiveObj;
};

/**
 * Filters and returns the records that are to be overridden based on the provided criteria.
 *
 * @param {Array} attributeValues - The array of attribute values to filter.
 * @param {string} attribute - The attribute to filter by.
 * @param {string} system - The system to filter by (for identifiers).
 * @param {string} attrCode - The attribute code to filter by (for address, name, phone, email).
 * @param {string} action - The action to filter by (replace, restore, inactive, invalid).
 * @param {string} incorrectValue - The incorrect value to filter by.
 * @param {string} code - The code to filter by (for identifiers).
 * @returns {Array} - The array of records to be overridden.
 */
export const getRecordsToOverride = (
  attributeValues,
  attribute,
  system,
  attrCode,
  action,
  incorrectValue,
  code,
) => {
  var attributeMaps = attributeValues.flat();

  switch (attribute) {
    case AttributeLabels.BIRTHDATE:
    case AttributeLabels.GENDER:
      if (action === ActionLabels.REPLACE) {
        return attributeMaps.filter(
          (v) =>
            v.get("displayValue") === incorrectValue &&
            !v.get("overridePresent"),
        );
      } else if (action == "restore") {
        return attributeMaps.filter(
          (v) =>
            v.get("displayValue") === incorrectValue &&
            v.get("overridePresent"),
        );
      }

    case AttributeLabels.IDENTIFIER:
      if (action === ActionLabels.REPLACE || action === ActionLabels.INACTIVE) {
        if (typeof code !== "undefined" && code !== "") {
          return attributeMaps.filter(
            (v) =>
              v.get("code") === code &&
              v.get("displayValue") === incorrectValue &&
              !v.has("system") &&
              v.get("use") !== "old" &&
              !v.get("overridePresent"),
          );
        } else {
          return attributeMaps.filter(
            (v) =>
              v.get("system") === system &&
              v.get("displayValue") === incorrectValue &&
              v.get("use") !== "old" &&
              !v.get("overridePresent"),
          );
        }
      } else if (action === ActionLabels.INVALID) {
        if (typeof code !== "undefined" && code !== "") {
          return attributeMaps.filter(
            (v) =>
              v.get("code") === code &&
              v.get("displayValue") === incorrectValue &&
              !v.has("system") &&
              !v.get("overridePresent"),
          );
        } else {
          return attributeMaps.filter(
            (v) =>
              v.get("system") === system &&
              v.get("displayValue") === incorrectValue &&
              !v.get("overridePresent"),
          );
        }
      } else if (action === ActionLabels.RESTORE) {
        if (typeof code !== "undefined" && code !== "") {
          return attributeMaps.filter(
            (v) =>
              v.get("code") === code &&
              v.get("displayValue") === incorrectValue &&
              !v.has("system") &&
              v.get("overridePresent"),
          );
        } else {
          return attributeMaps.filter(
            (v) =>
              v.get("system") === system &&
              v.get("displayValue") === incorrectValue &&
              v.get("overridePresent"),
          );
        }
      }

    case AttributeLabels.ADDRESS:
    case AttributeLabels.NAME:
    case AttributeLabels.PHONE:
    case AttributeLabels.EMAIL:
      if (action === ActionLabels.REPLACE || action === ActionLabels.INACTIVE) {
        return attributeMaps.filter(
          (v) =>
            v.get("attrCode") === attrCode &&
            v.get("displayValue") === incorrectValue &&
            v.get("use") !== "old" &&
            !v.get("overridePresent"),
        );
      } else if (action === ActionLabels.INVALID) {
        return attributeMaps.filter(
          (v) =>
            v.get("attrCode") === attrCode &&
            v.get("displayValue") === incorrectValue &&
            !v.get("overridePresent"),
        );
      } else if (action === ActionLabels.RESTORE) {
        return attributeMaps.filter(
          (v) =>
            v.get("attrCode") === attrCode &&
            v.get("displayValue") === incorrectValue &&
            v.get("overridePresent"),
        );
      }
  }
};

export const canShowSummaryTable = (values) => {
  const {
    override_action,
    override_attribute,
    override_attrCode,
    override_system,
  } = values;
  switch (override_attribute) {
    case AttributeLabels.ADDRESS:
    case AttributeLabels.NAME:
    case AttributeLabels.EMAIL:
    case AttributeLabels.PHONE:
      return (
        override_action !== "" &&
        override_attribute !== "" &&
        override_attrCode !== ""
      );

    case AttributeLabels.BIRTHDATE:
    case AttributeLabels.GENDER:
      return override_action !== "" && override_attribute !== "";

    case AttributeLabels.IDENTIFIER:
      return (
        override_action !== "" &&
        override_attribute !== "" &&
        override_system !== ""
      );

    default:
      return false;
  }

  return false;
};
